//成绩查询
import Achievement from '@/components/teacher/Achievement/achievement1';
import Achievements from '@/components/teacher/Achievement/achievement2';
import Achievementss from '@/components/teacher/Achievement/achievement3';
import Modify from '@/components/teacher/Achievement/modify';
//毕业设计
import Design from '@/components/teacher/Design/design';
import Design_wxzy from '@/components/teacher/Design/design_wxzy';
import Design_msg from '@/components/teacher/Design/design_msg';
import Selected from '@/components/teacher/Design/selected';
import guideDeal from '@/components/teacher/Design/guideDeal';
import doGuideRequst from '@/components/teacher/Design/doGuideRequst';
import guideDeal_unload from '@/components/teacher/Design/guideDeal_unload';
import guideStudentMsg from '@/components/teacher/Design/guideStudentMsg';
//培养方案
import Programme from '@/components/teacher/Programme/programme';
import Population from '@/components/teacher/Programme/population';
import Populations from '@/components/teacher/Programme/population2';
import Major from '@/components/teacher/Programme/major';
import Majors from '@/components/teacher/Programme/major2';
import Process from '@/components/teacher/Programme/process';
import Processs from '@/components/teacher/Programme/process2';
import Plan from '@/components/teacher/Programme/plan';
import Plans from '@/components/teacher/Programme/plan2';
import Speed from '@/components/teacher/Programme/speed';
//教室借用
import Classrooms from '@/components/teacher/Classroom/classroom';
import Classroomss from '@/components/teacher/Classroom/classroom2';
import Classroomsss from '@/components/teacher/Classroom/classroom3';
import Classroomsss_hbdl from '@/components/teacher/Classroom/classroom3_hbdl';
import Classroomssss from '@/components/teacher/Classroom/classroom4';
import Classroomsssss from '@/components/teacher/Classroom/classroom5';
import Application_record from '@/components/teacher/Classroom/application_record';
import RecordDetail from '@/components/teacher/Classroom/recordDetail';
//监考查询
import Invigilate from '@/components/teacher/Invigilate/invigilate';
import js_xkcx from '@/components/teacher/Invigilate/xkcx';
//学生成绩查询
import studentCjxx from '@/components/teacher/studentCjxx/studentCjxx';
import studentList from '@/components/teacher/studentCjxx/studentList';

//教学评价
import Evaluate from '@/components/teacher/Evaluate/evaluate';
import Evaluates from '@/components/teacher/Evaluate/evaluate2';
import Evaluatess from '@/components/teacher/Evaluate/evaluate3';
import Evaluatessfs from '@/components/teacher/Evaluate/evaluate3fs';
import Evaluatesss from '@/components/teacher/Evaluate/evaluate4';
import Evaluate_record from '@/components/teacher/Evaluate/evaluate_record';
import GradeDetails from '@/components/teacher/Evaluate/gradeDetails';

//教师评学
import jspxpc_find from '@/components/teacher/jspx/jspxpc_find';
import jspxkc_list from '@/components/teacher/jspx/jspxkc_list';
import jspxkc_edit from '@/components/teacher/jspx/jspxkc_edit';

//评价结果查询
import pjjgcxQuery from '@/components/teacher/pjjgcx/pjjgcxQuery';
import pjjgcxList from '@/components/teacher/pjjgcx/pjjgcxList';
//教学评价1
import Evaluate1 from '@/components/teacher/Evaluate1/evaluate';
import EvaluateSerach from '@/components/teacher/Evaluate1/evaluate2-serach';
import Evaluates1 from '@/components/teacher/Evaluate1/evaluate2';
import Evaluatess1 from '@/components/teacher/Evaluate1/evaluate3';
import EvaluatessTkjl from '@/components/teacher/Evaluate1/evaluate3-tkjl';
import EvaluatessScfj from '@/components/teacher/Evaluate1/evaluate3-scfj';
import EvaluatessQz from '@/components/teacher/Evaluate1/evaluate3-qz';
import SearchResult from '@/components/teacher/Evaluate1/searchResult';
import evaluateOnTime_teacher from '@/components/teacher/Evaluate1/evaluateOnTime';
import evaluateOnTime_recode from '@/components/teacher/Evaluate1/evaluateOnTime_recode';
//调课申请
import Changes from '@/components/teacher/Change/change_class';
import Changess from '@/components/teacher/Change/change_class2';
import Whole from '@/components/teacher/Change/whole';
import Wholes from '@/components/teacher/Change/whole2';
import Record from '@/components/teacher/Change/record';
import Records from '@/components/teacher/Change/record2';
import Recordss from '@/components/teacher/Change/record3';
import Recordsss from '@/components/teacher/Change/record4';
import Record_backups from '@/components/teacher/Change/record_backups';
import Part from '@/components/teacher/Change/part';
import Parts from '@/components/teacher/Change/part2';
import Teacher from '@/components/teacher/Change/teacher';
import alterTeacher from '@/components/teacher/Change/alterTeacher';
import Teachers from '@/components/teacher/Change/teacher2';
import Stop from '@/components/teacher/Change/stop';
import Stops from '@/components/teacher/Change/stop2';
import Nostop from '@/components/teacher/Change/noStop';
import Lessons from '@/components/teacher/Change/lessons';
import Lessones from '@/components/teacher/Change/lessons2';
import Audit from '@/components/teacher/Change/audit_records';

//课程表
import Surfaces1 from '@/components/teacher/Class/surfaces';
//课堂直播
import courseManage from '@/components/teacher/live/courseManage';
import expertLecture from '@/components/teacher/live/expertLecture';
import lectureResult from '@/components/teacher/live/lectureResult';
import supervise from '@/components/teacher/live/supervise';
import supervised from '@/components/teacher/live/supervised';
//考勤
import attendance from '@/components/teacher/Attendance/attendance';
import attendanceDetail from '@/components/teacher/Attendance/attendanceDetail';
import attendanceDetail_14621 from '@/components/teacher/Attendance/attendanceDetail_14621';
//审核
import examineIndex from '@/components/teacher/Examine/index';
//公共审核页面
import examineCommom from '@/components/teacher/Examine/commom/index';
import examineCommomSuccess from '@/components/teacher/Examine/commom/success';
import examineCommom_cj_stepOne from '@/components/teacher/Examine/commom/index_cj_setoOne';
//调课审核
import adjustList from '@/components/teacher/Examine/class-adjustment/list';
import adjustListDetail from '@/components/teacher/Examine/class-adjustment/listDetail';
//教室借用审核
import borrowingList from '@/components/teacher/Examine/classroom-borrowing/list';
import borrowingListDetail from '@/components/teacher/Examine/classroom-borrowing/listDetail';
//成绩录入审核
import searchScore from '@/components/teacher/Examine/score-entry/search';
import scoreList from '@/components/teacher/Examine/score-entry/list';
import scoreListDetail from '@/components/teacher/Examine/score-entry/listDetail';

//考务
import ExaminationIndex from '@/components/teacher/Examination/index';
//监考调代
import ExamSearch from '@/components/teacher/Examination/invigilation-replace/search';
import ExamSearchResult from '@/components/teacher/Examination/invigilation-replace/searchResult';
import ExamReplace from '@/components/teacher/Examination/invigilation-replace/replace';
//随堂考试
import ClassList from '@/components/teacher/Examination/classroom-test/list';
import ClassApply from '@/components/teacher/Examination/classroom-test/apply';
import ClassApplySuccess from '@/components/teacher/Examination/classroom-test/applySuccess';

//教材
import teacherTextbook from '@/components/teacher/Textbook/textbook';
import teacherTextbook_Details from '@/components/teacher/Textbook/textbook_Details';
//教学课程查询
import teacherCuseFind from '@/components/teacher/teachCuseFind/teaChFind';
import teacherCuseFindList from '@/components/teacher/teachCuseFind/teaChFindList';
//各类课表查询
import surfaAllTypeList from "@/components/teacher/teachCuseAll/typeList";
import surCuseAll_Find from "@/components/teacher/teachCuseAll/findViwe";
import surCuseAll_Find_time from "@/components/teacher/teachCuseAll/findViwe_time";
import searchCurAllList from "@/components/teacher/teachCuseAll/surfacesAll";
import searchCurAllList_time from "@/components/teacher/teachCuseAll/surfacesAll_time";
//成绩录入查询
import scoreEntry from "@/components/teacher/scoreEntry/index";
import scoreEntryDetails from "@/components/teacher/scoreEntry/details";
import scoreEntryDetails_jljc from "@/components/teacher/scoreEntry/details_jljc";
//教师缓考审核
import js_jshksh from "@/components/teacher/Examine/jshksh/jshkshList";
import js_jshkshDetail from "@/components/teacher/Examine/jshksh/jshkshListDetail"
import js_jshksh_sh from "@/components/teacher/Examine/jshksh/jshkSh";
//卓越计划
import zyjhDkxz from "@/components/teacher/zyjh/zyjhDkxz";
import zyjhDk from "@/components/teacher/zyjh/zyjhDk";
//教学进度
import jxjdgl from "@/components/teacher/jxjdgl/jxjdglindex";
import jxjdgl_deallist from "@/components/teacher/jxjdgl/jxjdgl_deallist";
import jxjdgl_dataEdatOrAdd from "@/components/teacher/jxjdgl/jxjdgl_dataEdatOrAdd";
import jxjdgl_dataViwe from "@/components/teacher/jxjdgl/jxjdgl_dataViwe";
//外聘教师申请审核
import wpjsBar from "@/components/teacher/Examine/wpjsAudit/wpjsBar";

// 实验室扫码
const teacherRoute = [
    {
        path: '/teacher/create',
        name: 'teacherCreate',
        meta: {
            title: '创建课堂交流群'
        },
        component: () => import('@/components/teacher/createGroup/index.vue')
    },
    /**
     * 审核
     */
    {
        path: '/teacher/verifyMenu',
        name: 'verifyMenu',
        meta: {
            title: '审核'
        },
        component: () => import('@/components/teacher/verify/index.vue') //审核菜单
    },
    // 计划微调审核
    {
        path: '/teacher/verifyIndex',
        name: 'verifyIndex',
        meta: {
            title: ''
        },
        component: () => import('@/components/teacher/verify/plan/index.vue') //审核列表
    },
    {
        path: '/teacher/verifyDetail',
        name: 'verifyDetail',
        meta: {
            title: ''
        },
        component: () => import('@/components/teacher/verify/plan/detail.vue') //审核详情
    },
    // 书目申请审核
    {
        path: '/teacher/bookIndex',
        name: 'bookIndex',
        meta: {
            title: '审核'
        },
        component: () => import('@/components/teacher/verify/book/index.vue') //审核列表
    },
    {
        path: '/teacher/bookDetail',
        name: 'bookDetail',
        meta: {
            title: '审核'
        },
        component: () => import('@/components/teacher/verify/book/detail.vue') //审核详情
    },
    {
        path: "/wpjsBorrow",
        component: wpjsBar,
        redirect: "/wpjsindex",
        children: [
          {
            path: "/wpjsindex",
            name: "wpjsBorrow",
            component: () => import('@/components/teacher/Examine/wpjsAudit/index.vue')
          },
          {
            path: "/wpjsList",
            name: "wpjsList",
            component: () => import('@/components/teacher/Examine/wpjsAudit/wpjsList.vue')
          }
        ]
    },
    {
        path: "/wpjsListDetail",
        name: "wpjsListDetail",
        component: () => import('@/components/teacher/Examine/wpjsAudit/wpjsDetail.vue')
    },
    {
        path: "/stksBorrow",
        component: () => import('@/components/teacher/Examine/stksAudit/stksBar.vue'),
        redirect: "/stksindex",
        children: [
          {
            path: "/stksindex",
            name: "stksindex",
            component: () => import('@/components/teacher/Examine/stksAudit/index.vue')
          },
          {
            path: "/stksList",
            name: "stksList",
            component: () => import('@/components/teacher/Examine/stksAudit/stksList.vue')
          }
        ]
    },
    {
        path: "/stksDetail",
        name: "stksDetail",
        component: () => import('@/components/teacher/Examine/stksAudit/stksDetail.vue')
    },
    {
        path: '/achievement1',
        name: 'achievement1',
        component: Achievement
    },
    {
        path: '/achievement2',
        name: 'achievement2',
        component: Achievements
    },
    {
        path: '/achievement3',
        name: 'achievement3',
        component: Achievementss
    },
    {
        path: '/modify',
        name: 'modify',
        component: Modify
    },
    {
        path: '/design',
        name: 'design',
        component: sessionStorage.getItem("schoolCode")=='10848'?Design_wxzy:Design,
    },
    {
        path: '/design_msg',
        name: 'design_msg',
        component: Design_msg,
    },
    {
        path: '/design_wxzy',
        name: 'design_wxzy',
        component: Design_wxzy
    },
    {
        path: '/selected',
        name: 'selected',
        component: Selected
    },
    {
        path: '/programme',
        name: 'programme',
        component: Programme,
        meta:{
            title:'专业培养方案'
        }
    },
    {
        path: '/population',
        name: 'population',
        component: Population
    },
    {
        path: '/population2',
        name: 'population2',
        component: Populations
    },
    {
        path: '/plan',
        name: 'plan',
        component: Plan
    },
    {
        path: '/plan2',
        name: 'plan2',
        component: Plans
    },
    {
        path: '/major',
        name: 'major',
        component: Major
    },
    {
        path: '/major2',
        name: 'major2',
        component: Majors
    },
    {
        path: '/process',
        name: 'process',
        component: Process
    },
    {
        path: '/process2',
        name: 'process2',
        component: Processs
    },
    {
        path: '/classroom',
        name: 'classrooms',
        component: Classrooms
    },
    {
        path: '/classroom2',
        name: 'classroom2',
        component: Classroomss
    },
    {
        path: '/classroom3',
        name: 'classroom3',
        component: Classroomsss
    },
    {
        path: '/classroom3_hbdl',
        name: 'classroom3_hbdl',
        component: Classroomsss_hbdl
    },
    {
        path: '/classroom4',
        name: 'classroom4',
        component: Classroomssss
    },
    {
        path: '/classroom5',
        name: 'classroom5',
        component: Classroomsssss
    },
    {
        path: '/application_record',
        name: 'application_record',
        component: Application_record
    },
    {
        path: '/recordDetail',
        name: 'recordDetail',
        component: RecordDetail
    },
    {
        path: '/invigilate',
        name: 'invigilate',
        component: Invigilate,
        meta:{
            title:'教师监考查询'
        }
    },
    {
        path: '/studentCjxx',
        name: 'studentCjxx',
        component: studentCjxx,
        meta:{
            title:'学生成绩查询'
        }
    },
    {
        path: '/evaluate',
        name: 'evaluates',
        component: Evaluate,
        meta:{
            title:'教学评价'
        }
    },
    {
        path: '/evaluate1',
        name: 'evaluates1',
        component: Evaluate1,
        meta:{
            title:'教学评价'
        }
    },
    {
        path: '/change_class',
        name: 'change_class',
        component: Changes
    },
    {
        path: '/change_class2',
        name: 'change_class2',
        component: Changess
    },
    {
        path: '/exchangeCourse',
        name: 'exchangeCourse',
        component: () => import('@/components/teacher/Change/exchangeCourse.vue')
    },
    {
        path: '/exchangeCourse1',
        name: 'exchangeCourse1',
        component: () => import('@/components/teacher/Change/exchangeCourse1.vue')
    },
    {
        path: '/whole',
        name: 'whole',
        component: Whole
    },
    {
        path: '/whole2',
        name: 'whole2',
        component: Wholes
    },
    {
        path: '/record',
        name: 'record',
        component: Record
    },
    {
        path: '/record2',
        name: 'record2',
        component: Records
    },
    {
        path: '/record3',
        name: 'record3',
        component: Recordss
    },
    {
        path: '/record4',
        name: 'record4',
        component: Recordsss
    },
    {
        path: '/record_backups',
        name: 'record_backups',
        component: Record_backups
    },
    {
        path: '/teacher',
        name: 'teacher',
        component: Teacher,
        meta: {
            // keepAlive: true
        }
    },
    {
        path: '/alterTeacher',
        name: 'alterTeacher',
        component: alterTeacher
    },
    {
        path: '/teacher2',
        name: 'teacher2',
        component: Teachers
    },
    {
        path: '/part',
        name: 'part',
        component: Part
    },
    {
        path: '/part2',
        name: 'part2',
        component: Parts
    },
    {
        path: '/stop',
        name: 'stop',
        component: Stop
    },
    {
        path: '/stop2',
        name: 'stop2',
        component: Stops
    },
    {
        path: '/noStop',
        name: 'noStop',
        component: Nostop
    },
    {
        path: '/lessons',
        name: 'lessons',
        component: Lessons
    },
    {
        path: '/lessons2',
        name: 'lessons2',
        component: Lessones
    },
    {
        path: '/audit_records',
        name: 'audit_records',
        component: Audit
    },
    {
        path: '/evaluateIndex',
        name: 'evaluateIndex',
        component: () => import('@/components/teacher/Evaluate/index.vue')
    },
    {
        path: '/evaluateSerach',
        name: 'evaluateSerach',
        meta: {
            title: '教学评价搜索'
        },
        component: EvaluateSerach,
        meta:{
            title:'教学评价'
        }
    },
    {
        path: '/evaluate2',
        name: 'evaluate2',
        component: Evaluates,
        meta:{
            title:'教学评价'
        }
    },
    {
        path: '/evaluate21',
        name: 'evaluate21',
        component: Evaluates1,
        meta:{
            title:'教学评价'
        }
    },
    {
        path: '/evaluate3',
        name: 'evaluate3',
        component: Evaluatess,
        meta:{
            title:'教学评价'
        }
    },
  {
    path: '/evaluate3fs',
    name: 'evaluate3fs',
    component: Evaluatessfs,
    meta:{
      title:'教学评价'
    }
  },
    {
        path: '/evaluate31',
        name: 'evaluate31',
        component: Evaluatess1,
        meta:{
            title:'教学评价'
        }
    },
    {
        path: '/evaluatessTkjl',
        name: 'evaluatessTkjl',
        meta: {
            title: '教学评价'
        },
        component: EvaluatessTkjl
    },
    {
        path: '/evaluatessScfj',
        name: 'evaluatessScfj',
        meta: {
            title: '教学评价'
        },
        component: EvaluatessScfj
    },
    {
        path: '/evaluatessQz',
        name: 'evaluatessQz',
        meta: {
            title: '教学评价'
        },
        component: EvaluatessQz
    },
    {
        path: '/SearchResult',
        name: 'SearchResult',
        component: SearchResult
    },
    {
        path: '/evaluate4',
        name: 'evaluate4',
        component: Evaluatesss,
        meta:{
            title:'教学评价'
        }
    },
    {
        path: '/evaluate_record',
        name: 'evaluate_record',
        component: Evaluate_record,
        meta:{
            title:'教学评价'
        }
    },
    {
        path: '/jspx/jspxpc_find',
        name: 'jspxpc_find',
        component: jspxpc_find,
        meta:{
          title:'教师评学'
        }
    },{
        path: '/jspx/jspxkc_list',
        name: 'jspxkc_list',
        component: jspxkc_list,
        meta:{
            title:'教师评学'
        }
    },{
        path: '/jspx/jspxkc_edit',
        name: 'jspxkc_edit',
        component: jspxkc_edit,
        meta:{
            title:'教师评学'
        }
    },
    {
        path: '/gradeDetails',
        name: 'gradeDetails',
        component: GradeDetails
    },
    {
        path: '/speed',
        name: 'speed',
        component: Speed
    },
    {
        path: '/surfaces1',
        name: 'surfaces1',
        component: Surfaces1
    },
    //直播
    {
        path: '/teacher/courseManage',
        name: 'courseManage',
        component: courseManage
    },
    {
        path: '/teacher/expertLecture',
        name: 'expertLecture',
        component: expertLecture
    },
    {
        path: '/teacher/lectureResult',
        name: 'lectureResult',
        component: lectureResult
    },
    {
        path: '/teacher/supervise',
        name: 'supervise',
        component: supervise
    },
    {
        path: '/teacher/supervised',
        name: 'supervised',
        component: supervised
    },
    //考勤
    {
        path: '/teacher/attendance',
        name: 'attendance',
        component: attendance,
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/teacher/attendanceDetail',
        name: 'attendanceDetail',
        component: attendanceDetail
    },
    {
        path: '/teacher/attendanceDetail_14621',
        name: 'attendanceDetail_14621',
        component: attendanceDetail_14621
    },
    //审核
    {
        path: '/teacher/examineIndex',
        name: 'examineIndex',
        meta: {
            title: '审核'
        },
        component: examineIndex
    },
    {
        path: '/teacher/examine/examineCommom/:route/:route_params',
        name: 'examineCommom',
        component: examineCommom
    },
    {
        path: '/teacher/examine/examineCommom/:route/:route_params',
        name: 'examineCommom_cj_stepOne',
        component: examineCommom_cj_stepOne
    },
    {
        path: '/teacher/fileDetail',
        name: 'fileDetail',
        component: () => import('@/components/teacher/Examine/commom/main.vue')
    },
    {
        path: '/teacher/filePreview',
        name: 'filePreview',
        component: () => import('@/components/teacher/Examine/commom/filePreview.vue')
    },
    {
        path: '/teacher/examine/examineCommomSuccess',
        name: 'examineCommomSuccess',
        component: examineCommomSuccess
    },
    {
        path: '/teacher/examine/adjustList',
        name: 'adjustList',
        component: adjustList
    },
    {
        path: '/teacher/examine/adjustListDetail/:route_params',
        name: 'adjustListDetail',
        component: adjustListDetail
    },
    {
        path: '/teacher/examine/adjustListDetailCas',
        name: 'adjustListDetailCas',
        component: () => import('@/components/teacher/Examine/class-adjustment/listDetail.vue')
    },
    {
        path: '/teacher/examine/borrowingList',
        name: 'borrowingList',
        component: borrowingList
    },
    {
        path: '/teacher/examine/borrowingListDetail/:route_params',
        name: 'borrowingListDetail',
        component: borrowingListDetail
    },
    {
        path: '/teacher/examine/searchScore',
        name: 'searchScore',
        component: searchScore
    },
    {
        path: '/teacher/examine/scoreList',
        name: 'scoreList',
        component: scoreList
    },
    {
        path: '/teacher/examine/scoreListDetail',
        name: 'scoreListDetail',
        component: scoreListDetail
    },
    //考务
    {
        path: '/teacher/examinationIndex',
        name: 'examinationIndex',
        component: ExaminationIndex,
        meta:{
            title:'教师监考查询'
        }
    },
    //考务调代
    {
        path: '/teacher/examSearch',
        name: 'examSearch',
        component: ExamSearch
    },
    {
        path: '/teacher/examSearchResult/:route_params',
        name: 'examSearchResult',
        component: ExamSearchResult
    },
    {
        path: '/teacher/examReplace/:route_params',
        name: 'examReplace',
        component: ExamReplace
    },
    //随堂考试
    {
        path: '/teacher/classList',
        name: 'classList',
        component: ClassList
    },
    {
        path: '/teacher/classApply/:route_params',
        name: 'classApply',
        component: ClassApply
    },
    {
        path: '/teacher/classApplySuccess',
        name: 'classApplySuccess',
        component: ClassApplySuccess
    },
    //教材
    {
        path: '/teacher/textbook',
        name: 'teacherTextbook',
        component: teacherTextbook
    },
    {
        path: '/teacher/textbook_Details',
        name: 'teacherTextbook_Details',
        component: teacherTextbook_Details
    },
    // 学风测评
    {
        path: '/teacher/learnHome',
        name: 'learnHome',
        component: () => import('@/components/teacher/Evaluate/learnAssessment/home.vue')
    },
    {
        path: '/teacher/learnIndex',
        name: 'learnIndex',
        component: () => import('@/components/teacher/Evaluate/learnAssessment/index.vue')
    },
    {
        path: '/teacher/styleEvaluate',
        name: 'styleEvaluate',
        component: () => import('@/components/teacher/Evaluate/learnAssessment/style.vue')
    },
    {
        path: '/teacher/detailEvaluate',
        name: 'TeaDetailEvaluate',
        component: () => import('@/components/teacher/Evaluate/learnAssessment/detail.vue')
    },
    // 工作量查询
    {
        path: '/teacher/workload',
        name: 'workload',
        component: () => import('@/components/teacher/Evaluate/workload/index.vue')
    },
    {
        path: '/teacher/workloadFind',
        name: 'workloadFind',
        component: () => import('@/components/teacher/Evaluate/workload/detail.vue')
    },
    // 指导培养方案审核
    {
        path: '/teacher/guideIndex',
        name: 'guideIndex',
        component: () => import('@/components/teacher/Examine/guide/index.vue')
    },
    {
        path: '/teacher/guideMain',
        name: 'guideMain',
        component: () => import('@/components/teacher/Examine/guide/main.vue')
    },
    // 新增课程审核
    {
        path: '/teacher/courseAudit',
        name: 'courseAudit',
        component: () => import('@/components/teacher/Examine/addAudit/index.vue')
    },
    {
        path: '/teacher/courseAuditMain',
        name: 'courseAuditMain',
        component: () => import('@/components/teacher/Examine/addAudit/main.vue')
    },
    // 图片上传
    {
        path: '/upload',
        name: 'upload',
        component: () => import('@/components/pages/upload.vue')
    },
    {
        path: '/uploadFile',
        name: 'uploadFile',
        component: () => import('@/components/pages/uploadFile.vue')
    },
    // // 测试
    // {
    //   path: "/test",
    //   name: "test",
    //   component: () => import("@/components/pages/test.vue")
    // },
    // 班级课表
    {
        path: '/teacher/class-timetable-search',
        name: 'classTimeTableSearch',
        component: () => import('@/components/teacher/class-timetable/search.vue')
    },
    {
        path: '/teacher/class-timetable-detail/:route_params',
        name: 'classTimeTableDetail',
        component: () => import('@/components/teacher/class-timetable/timetable.vue')
    },
  // 全校课表
  {
    path: '/teacher/class-timetable-detailqx/:route_params',
    name: 'classTimeTableDetailqx',
    component: () => import('@/components/teacher/class-timetable/timetableqx.vue')
  },
    {
        path: '/disk',
        name: 'disk',
        component: () => import('@/components/teacher/disk/index.vue')
    },
    // 考场信息查询
    {
        path: '/teacher/examRoom',
        name: 'examRoom',
        component: () => import('@/components/teacher/Examination/place/index.vue'),
        meta: {
            title: '考场信息查询'
        }
    },
    // 课表查询 演示
    {
        path: '/teacher/searchIndex',
        name: 'searchIndex',
        component: () => import('@/components/teacher/TimetableQuery/index.vue'),
        meta: {
            title: '课表查询'
        }
    },
    {
        path: '/teacher/searchCondition',
        name: 'searchCondition',
        component: () => import('@/components/teacher/TimetableQuery/condition.vue'),
        meta: {
            title: '课表查询'
        }
    },
    {
        path: '/teacher/searchResult',
        name: 'searchResult',
        component: () => import('@/components/teacher/TimetableQuery/result.vue'),
        meta: {
            title: '课表查询'
        }
    },
    // 空闲教室
    {
        path: '/restClassroom',
        name: 'restClassroom',
        component: () => import('@/components/teacher/restClassroom/index.vue'),
        meta: {
            title: '今日空闲教室'
        }
    },
    {
        path: '/restDetail',
        name: 'restClassroom',
        component: () => import('@/components/teacher/restClassroom/restDetail.vue'),
        meta: {
            title: '今日空闲教室'
        }
    },
    {
        path: '/examSchedule',
        name: 'examSchedule',
        component: () => import('@/components/teacher/examSchedule/index.vue'),
        meta: {
            title: '考试安排查询',
            keepAlive: true
        }
    },
    {
        path: '/examSchedule/list',
        name: 'examSchedule/list',
        component: () => import('@/components/teacher/examSchedule/list.vue')
    },

    //教学课程查询
    {
        path: '/teacher/jxkccx',
        name: 'teacherCuseFind',
        component: teacherCuseFind,
        meta: {
            title: '教学课程查询'
        }
    },
    {
        path: '/teacher/searchCurContex',
        name: 'teacherCuseFindList',
        component: teacherCuseFindList,
        meta: {
            title: '教学课程查询'
        }
    },
  {
    path: "/teacher/surfaAll",
    name: "surfaAllTypeList",
    component: surfaAllTypeList,
    meta: {
      title: "各类课表查询"
    }
  },
  {
    path: "/teacher/surCuseAll_Find",
    name: "surCuseAll_Find",
    component: surCuseAll_Find,
    meta: {
      title: "各类课表查询"
    }
  },
  {
    path: "/teacher/surCuseAll_Find_time",
    name: "surCuseAll_Find_time",
    component: surCuseAll_Find_time,
    meta: {
      title: "各类课表查询"
    }
  },
  {
    path: "/teacher/searchCurAllList",
    name: "searchCurAllList",
    component: searchCurAllList,
    meta: {
      title: "各类课表查询"
    }
  },
  {
    path: "/teacher/searchCurAllList_time",
    name: "searchCurAllList_time",
    component: searchCurAllList_time,
    meta: {
      title: "各类课表查询"
    }
  },
  {
    path: "/teacher/js_xkcx",
    name: "js_xkcx",
    component: js_xkcx,
    meta: {
        title: "巡考查询"
    }
  },
  {
    path: "/teacher/scoreEntry",
    name: "scoreEntry",
    component: scoreEntry,
    meta: {
      title: "成绩录入查询"
    }
  },
  {
    path: "/teacher/scoreEntryDetails",
    name: "scoreEntryDetails",
    component: scoreEntryDetails,
    meta: {
      title: "学生成绩"
    }
  },
  {
    path: "/teacher/scoreEntryDetails_jljc",
    name: "scoreEntryDetails_jljc",
    meta: {
      title: "学生成绩"
    },
    component: scoreEntryDetails_jljc,
  },
  {
    path: "/teacher/jshksh",
    name: "js_jshksh",
    component: js_jshksh,
    meta: {
      title: "教师缓考审核"
    }
  },
  {
    path: "/teacher/jshkshDetail/:route_params",
    name: "js_jshkshDetail",
    component: js_jshkshDetail,
    meta: {
      title: "教师缓考审核"
    }
  },
  {
    path: "/teacher/js_jshksh_sh/:route_params",
    name: "js_jshksh_sh",
    component: js_jshksh_sh,
    meta: {
      title: "教师缓考审核"
    }
  },
  {
    path: "/design/guideDeal",
    name: "guideDeal",
    component: guideDeal
  },
  {
    path: "/design/doGuideRequst",
    name: "doGuideRequst",
    component: doGuideRequst
  },
  {
    path: "/design/guideDeal_unload",
    name: "guideDeal_unload",
    component: guideDeal_unload

  },
  {
    path: "/studentList/:route_params",
    name: "studentList",
    component: studentList,
    meta:{
        title:'学生成绩查询'
    }

  },
  {
    path: '/pjjgcx/pjjgcxQuery',
    name: 'pjjgcxQuery',
    component: pjjgcxQuery,
    meta:{
        title:'评价结果查询'
    }
  },
  {
    path: "/pjjgcx/pjjgcxList/:route_params",
    name: "pjjgcxList",
    component: pjjgcxList,
    meta:{
        title:'评教结果查询'
    }

  },
  {
    path: "/teacher/zyjhDkxz",
    name: "zyjhDkxz",
    component: zyjhDkxz
  },
  {
    path: "/teacher/zyjhDk",
    name: "zyjhDk",
    component: zyjhDk
  },

  {
    path: "/design/guideStudentMsg",
    name: "guideStudentMsg",
    component: guideStudentMsg
  },
  {
    path: "/teacher/jxjdgl",
    name: "jxjdgl",
    component: jxjdgl
  },
  {
    path: "/teacher/jxjdgl_deallist",
    name: "jxjdgl_deallist",
    component: jxjdgl_deallist
  },
  {
    path: "/teacher/jxjdgl_dataEdatOrAdd",
    name: "jxjdgl_dataEdatOrAdd",
    component: jxjdgl_dataEdatOrAdd
  },

  {
    path: "/teacher/jxjdgl_dataViwe",
    name: "jxjdgl_dataViwe",
    component: jxjdgl_dataViwe
  },

  {
    path: "/teacher/evaluateOnTime",
    name: "evaluateOnTime_teacher",
    component: evaluateOnTime_teacher
  },
  {
    path: "/teacher/evaluateOnTime_recode",
    name: "evaluateOnTime_recode",
    component: evaluateOnTime_recode
  },
  // 班级课表
  {
    path: '/teacher/class-timetable-search',
    name: 'classTimeTableSearch',
    component: () => import('@/components/teacher/class-timetable/search.vue')
  },
  {
    path: '/teacher/tea_ktpj',
    name: 'tea_ktpj',
    component: () => import('@/components/newPages/teacher/classroomAssessment/index.vue')
  },
  {
    path: '/teacher/tea_ktpj_list',
    name: 'tea_ktpj_list',
    component: () => import('@/components/newPages/teacher/classroomAssessment/assessmentList.vue')
  },
  {
    path: '/teacher/tea_ktpj_list_d',
    name: 'tea_ktpj_list',
    component: () => import('@/components/newPages/teacher/classroomAssessment/listDetail.vue')
  },
  {
    path: '/teacher/tea_assessment',
    name: 'tea_assessment',
    component: () => import('@/components/newPages/teacher/classroomAssessment/assessment.vue')
  },
  {
    path: '/teacher/cjwt',
    name: 'tea_cjwt',
    component: () => import('@/components/teacher/cjwt/index.vue')
  },
  {
    path: '/teacher/wjwtDetail',
    name: 'tea_cjwtdetail',
    component: () => import('@/components/teacher/cjwt/wjwtDetail.vue')
  },
  {
    path: '/teacher/cjlrss',
    name: 'cjlrss',
    component: () => import('@/components/teacher/xscjlrAudit/index.vue'),
    meta: {
        title: '成绩录入送审',
        keepAlive: true
    }
  },
  {
    path: '/teacher/cjlr_detail',
    name: 'cjlr_detail',
    component: () => import('@/components/teacher/xscjlrAudit/cjlr_detail.vue'),
    meta: {
        title: '成绩录入送审',
        keepAlive: true
    }
  },
  {
    path: '/teacher/defereedExamination',
    name: 'defereedExamination',
    component: () => import('@/components/teacher/deferredExamination/main.vue')
  },
  {
    path: '/teacher/defereedExamination/:route/:route_params',
    name: 'defereedExaminationAuditing',
    component: () => import('@/components/teacher/deferredExamination/index.vue')
  },
  {
    path: '/xscjck/index',
    name: 'xscjck',
    component: () => import('@/components/teacher/xscjck/index.vue')
  },
  {
    path: '/hkckQuery',
    name: 'hkckQuery',
    component: () => import('@/components/teacher/Examine/hksh/hkckQuery.vue')
  },
  {
    path: '/hkcxIndex',
    name: 'hkcxIndex',
    component: () => import('@/components/teacher/Examine/hksh/hkcxIndex.vue')
  },
  {
    path: '/applyDetail',
    name: 'applyDetail',
    component: () => import('@/components/teacher/Examine/hksh/applyDetail.vue')
  },
  {
    path: '/kctdshList',
    name: 'kctdshList',
    component: () => import('@/components/teacher/Examine/kctdsh/kctdshList.vue')
  },
  {
    path: '/cjrdDetail',
    name: 'cjrdDetail',
    component: () => import('@/components/teacher/Examine/kctdsh/cjrdxq.vue')
  },
  {
    path: '/teacher/examine/bdkqshList',
    name: 'bdkqshList',
    component: () => import('@/components/teacher/Examine/bdkqsh/list.vue')
  },
  {
    path: '/teacher/examine/bdxgkqshListDetail',
    name: 'bdxgkqshListDetail',
    component: () => import('@/components/teacher/Examine/bdkqsh/listDetail.vue')
  },
  {
    path: '/jsjxap/index',
    name: 'jsjxapIndex',
    component: () => import('@/components/teacher/kaowu/wdjxap/index.vue')
  },
  {
    path: '/jsjxap/detail',
    name: 'jsjxapDetail',
    component: () => import('@/components/teacher/kaowu/wdjxap/listDetail.vue')
  },
  {
    path: '/jsjkcx/index',
    name: 'jsjkcxIndex',
    component: () => import('@/components/teacher/kaowu/wdjk/index.vue')
  },
  {
    path: '/jsjkcx/detail',
    name: 'jsjkcxDetail',
    component: () => import('@/components/teacher/kaowu/wdjk/listDetail.vue')
  },
  {
    path: '/jskcksap/index',
    name: 'jskcksapIndex',
    component: () => import('@/components/teacher/kaowu/kcksap/index.vue')
  },
  {
    path: '/jskcksap/detail',
    name: 'jskcksapDetail',
    component: () => import('@/components/teacher/kaowu/kcksap/listDetail.vue')
  },
  {
    path: '/jsjbxx/index',
    name: 'jsjbxxIndex',
    component: () => import('@/components/teacher/jsjbxx/index.vue')
  },
  // 考务
  {
    path: '/kwapsq/index',
    name: 'kwapsqIndex',
    component: () => import('@/components/teacher/kaowu/kwapsq/index.vue')
  },
  {
    path: '/kwapsq/sqform',
    name: 'kwapsqform',
    component: () => import('@/components/teacher/kaowu/kwapsq/sqform.vue')
  },
  {
    path: '/kwapsq/shjl',
    name: 'kwapsqShjl',
    component: () => import('@/components/teacher/kaowu/kwapsq/shjl.vue')
  },
  {
    path: '/kwapsq/xs',
    name: 'kwapsqXs',
    component: () => import('@/components/teacher/kaowu/kwapsq/xs.vue')
  },
  {
    path: '/kwapsq/detail',
    name: 'kwapsqXq',
    component: () => import('@/components/teacher/kaowu/kwapsq/detail.vue')
  },
  {
    path: '/kwapsq/ss',
    name: 'kwapsqSs',
    component: () => import('@/components/teacher/kaowu/kwapsq/ss.vue')
  },
  {
    path: '/kwapSh/index',
    name: 'kwapSh',
    component: () => import('@/components/teacher/kaowu/kwapSh/index.vue')
  },
  {
    path: '/kwapSh/examine',
    name: 'kwapShExamine',
    component: () => import('@/components/teacher/kaowu/kwapSh/examine.vue')
  },
  {
    path: '/teacher/tkglIndex',
    name: 'teacherTkglIndex',
    component: () => import('@/components/teacher/tkgl/tkglIdex.vue')
  },
  {
    path: '/teacher/tkglViwe',
    name: 'teacherTkglViwe',
    component: () => import('@/components/teacher/tkgl/tkViwePage.vue')
  },
  {
    path: '/teacher/tkglViweSee',
    name: 'teacherTkglViweSee',
    component: () => import('@/components/teacher/tkgl/tkViwePageSee.vue')
  },
  {
    path: '/teacher/mytkglIndex',
    name: 'teacherMytkglIndex',
    component: () => import('@/components/teacher/tkgl/mytkglIdex.vue')
  },
  {
    path: '/teacher/tkglViweMx',
    name: 'teacherTkglViweMx',
    component: () => import('@/components/teacher/tkgl/tkViwePageSee.vue')
  },
  {
    path: '/xsjssh/index',
    name: 'xsjsshIndex',
    component: () => import('@/components/teacher/Examine/xsjssh/index.vue')
  },
  {
    path: '/xsjssh/detail',
    name: 'xsjsshDetail',
    component: () => import('@/components/teacher/Examine/xsjssh/detail.vue')
  }
];
export default teacherRoute;



// WEBPACK FOOTER //
// ./src/router/teacher.js